<template lang="pug">
span(:style="{ height, width: computedWidth }").SkeletonBox
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'skeleton-box',
})
export default class SkeletonBox extends Vue {
  @Prop({
    default: 100,
    type: Number,
  })
  maxWidth!: number;

  @Prop({
    default: 80,
    type: Number,
  })
  minWidth!: number;

  @Prop({
    default: '1em',
    type: String,
  })
  height!: string;

  @Prop({
    default: null,
    type: String,
  })
  width!: string | number | null;

  get computedWidth() {
    return this.width || `${Math.floor((Math.random() * (this.maxWidth - this.minWidth)) + this.minWidth)}%`;
  }
}
</script>

<style scoped lang="less">
.SkeletonBox {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  overflow: hidden;
  // background-color: #f2f3f8;
  background-color: #ddf1c4;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.2) 20%,
        rgba(255, 255, 255, 0.5) 60%,
        rgba(255, 255, 255, 0)
    );
    animation: shimmer 3s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
